export { default } from './CityGarbagesPage'
